import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Switch } from './ui/switch';
import { Bell, BellOff, Check } from 'lucide-react';
import { requestNotificationPermission, sendNotification } from '../utils/notifications';
import { toast } from '../hooks/use-toast';

const NotificationSettings = () => {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [permission, setPermission] = useState('default');
  const [showDeniedMessage, setShowDeniedMessage] = useState(false);

  useEffect(() => {
    if ('Notification' in window) {
      setPermission(Notification.permission);
      setNotificationsEnabled(Notification.permission === 'granted');
    }
  }, []);

  const handleToggleNotifications = async () => {
    if (!notificationsEnabled) {
      const granted = await requestNotificationPermission();
      if (granted) {
        setNotificationsEnabled(true);
        setPermission('granted');
        setShowDeniedMessage(false);
        sendNotification('¡Notificaciones activadas!', {
          body: 'Recibirás recordatorios de tus citas próximas',
          icon: '/favicon.ico'
        });
        toast({
          title: '¡Notificaciones activadas!',
          description: 'Recibirás recordatorios de tus citas',
        });
      } else {
        setPermission('denied');
        setShowDeniedMessage(true);
        toast({
          title: 'Permiso denegado',
          description: 'No se pueden enviar notificaciones. Por favor, habilita los permisos en tu navegador.',
          variant: 'destructive',
        });
      }
    } else {
      setNotificationsEnabled(false);
      toast({
        title: 'Notificaciones desactivadas',
        description: 'No recibirás más recordatorios',
      });
    }
  };

  const sendTestNotification = () => {
    if (notificationsEnabled) {
      sendNotification('Notificación de prueba', {
        body: 'Este es un ejemplo de cómo se verán tus recordatorios de citas',
        icon: '/favicon.ico'
      });
    }
  };

  return (
    <Card className="border-l-4 border-l-blue-500">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {notificationsEnabled ? (
              <Bell className="w-5 h-5 mr-2 text-blue-500" />
            ) : (
              <BellOff className="w-5 h-5 mr-2 text-gray-400" />
            )}
            <div>
              <CardTitle className="text-base">Notificaciones</CardTitle>
              <CardDescription className="text-xs mt-0.5">
                Recordatorios 2h antes de cada cita
              </CardDescription>
            </div>
          </div>
          <Switch
            id="notifications"
            checked={notificationsEnabled}
            onCheckedChange={handleToggleNotifications}
          />
        </div>
      </CardHeader>

      {notificationsEnabled && (
        <CardContent className="pt-0 pb-3">
          <Button
            onClick={sendTestNotification}
            variant="outline"
            size="sm"
            className="w-full hover:bg-blue-50 hover:text-blue-600 hover:border-blue-300"
          >
            <Check className="w-3 h-3 mr-1.5" />
            <span className="text-xs">Probar notificación</span>
          </Button>
        </CardContent>
      )}

      {showDeniedMessage && permission === 'denied' && (
        <CardContent className="pt-0 pb-3">
          <div className="p-2 bg-red-50 border border-red-200 rounded text-xs text-red-800">
            Notificaciones bloqueadas. Cambia los permisos en tu navegador.
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default NotificationSettings;